import { ChevronRightIcon } from './ds/icons';
import Eyebrow from './ds/Eyebrow';

const GUIDES = [
  {
    label: 'Get started',
    desc: 'Deploy your first web app in five minutes.',
    href: 'https://www.back4app.com/docs-containers',
  },
  {
    label: 'Creating a new web application',
    desc: 'Repository, build command, and env vars.',
    href: 'https://www.back4app.com/docs-containers/integrate-with-github',
  },
  {
    label: 'Manage your web application',
    desc: 'Redeploy, restart, scale, and domains.',
    href: 'https://www.back4app.com/docs-containers/deployment-process',
  },
  {
    label: 'Troubleshooting',
    desc: 'Read build logs and fix failed deploys.',
    href: 'https://www.back4app.com/docs-containers/troubleshooting',
  },
];

const Guides = () => (
  <div className="flex flex-col gap-3">
    <Eyebrow>guides &amp; docs</Eyebrow>

    {/* Cards on desktop, where there is room for the one-liner; a plain list
        with a chevron on mobile, where there is not. */}
    <div className="hidden lg:grid grid-cols-4 gap-3">
      {GUIDES.map(guide => (
        <a
          key={guide.href}
          href={guide.href}
          target="_blank"
          rel="noreferrer"
          className="b4-focus flex flex-col gap-1.5 p-4 rounded-card border border-navy-500 bg-navy-700 hover:bg-navy-600 transition-colors duration-[120ms]"
        >
          <span className="text-ds-135 font-medium text-white leading-[1.4]">{guide.label}</span>
          <span className="text-ds-125 text-navy-200 leading-[1.45]">{guide.desc}</span>
        </a>
      ))}
    </div>

    <div className="lg:hidden rounded-card border border-navy-500 bg-navy-700 overflow-hidden flex flex-col">
      {GUIDES.map((guide, i) => (
        <a
          key={guide.href}
          href={guide.href}
          target="_blank"
          rel="noreferrer"
          className={`b4-focus flex items-center justify-between gap-2.5 min-h-[48px] px-4 text-ds-135 font-medium text-navy-100 ${i ? 'border-t border-navy-500' : ''}`}
        >
          <span>{guide.label}</span>
          <ChevronRightIcon size={14} className="text-navy-300" />
        </a>
      ))}
    </div>
  </div>
);

export default Guides;
